<template>
  <v-container fluid>
    <mf-action-buttons
      :primary-button="primaryButton"
      :secondary-button="secondaryButton"
      :extra-button="extraButton"
      :cancel-button="{
        text: 'Cancelar',
        action: () => $emit('cancel'),
        isVisible: !readOnly,
      }"
    />
  </v-container>
</template>

<script>
export default {
  props: {
    status: String,
    isCreate: Boolean,
    loading: Boolean,
    readOnly: Boolean,
  },
  computed: {
    showDelete() {
      return Boolean(this.status === 'draft')
    },
    showDisable() {
      return Boolean(this.status === 'active' || this.status === 'scheduled')
    },
    showEnable() {
      return Boolean(!this.status || this.status === 'draft' || this.status === 'paused' || this.isCreate)
    },
    showSaveDraft() {
      return ['draft'].includes(this.status) || this.isCreate
    },
    showSave() {
      return ['scheduled'].includes(this.status)
    },
    extraButton() {
      if (this.showDelete && !this.readOnly) {
        return {
          text: 'Deletar',
          action: () => this.$emit('delete'),
          isVisible: true,
        }
      }
      if (this.showDisable && !this.readOnly) {
        return {
          text: 'Desativar',
          action: () => this.$emit('disable'),
          isVisible: true,
        }
      }
      return {
        text: '',
        isVisible: false,
      }
    },
    secondaryButton() {
      if (this.showSaveDraft && !this.readOnly) {
        return {
          text: 'Salvar alterações',
          action: () => this.$emit('saveDraft'),
          isVisible: true,
          isDisabled: this.loading,
          isLoading: this.$wait.is(['create-flyer', 'edit-flyer']),
        }
      }
      if (this.showSave && !this.readOnly) {
        return {
          text: 'Salvar alterações',
          action: () => this.$emit('enable'),
          isVisible: true,
          isDisabled: this.loading,
          isLoading: this.$wait.is(['create-flyer', 'edit-flyer']),
        }
      }
      return {
        text: '',
        isVisible: false,
      }
    },
    primaryButton() {
      if (this.showEnable && !this.readOnly) {
        return {
          text: 'Ativar',
          action: () => this.$emit('enable'),
          isVisible: true,
          isLoading: this.$wait.is(['create-flyer', 'edit-flyer']),
          isDisabled: this.loading,
        }
      }
      if (this.readOnly) {
        return {
          text: 'Fechar',
          action: () => this.$emit('cancel'),
          isVisible: true,
        }
      }
      return {
        text: '',
        isVisible: false,
      }
    },
  },
}
</script>
